// Render-side strip for the S13 carryover bug where assistant messages
// rendered with literal `[drill_sergeant] [drill_sergeant]` prefixes leaked
// from the prompt template (GROUND_STATE.md §S13 carryover).
//
// Phase A.1 scope: render-side only. Prompt-side suppression is a separate
// S16+ design conversation — the strip here is the defensive net so the leak
// doesn't keep reaching production while that conversation runs.
//
// Strip rule: leading `[<persona_slug>]` (optionally repeated, optionally
// followed by whitespace) where `<persona_slug>` is one of the 14 registered
// persona ids. Unknown slugs are NOT stripped — that preserves any legitimate
// bracketed prefix a coach might author (e.g. `[note]`).

const PERSONA_SLUGS = [
  'supportive',
  'drill_sergeant',
  'analytical',
  'mentor',
  'hype',
  'calm_zen',
  'dry_humour',
  'therapist',
  'scientist',
  'nonna',
  'good_cop',
  'bad_cop',
  'duo_good_bad',
  'duo_sergeant_therapist',
] as const;

const TAG_LEAK_RE = new RegExp(
  `^(\\[(?:${PERSONA_SLUGS.join('|')})\\]\\s*)+`,
  'i',
);

export function stripPersonaTags(content: string): string {
  return content.replace(TAG_LEAK_RE, '');
}
